import React from "react";
import * as F from "./Footer-style";


export default function FooterContacts() {
   return (
      <div>
         <F.FooterTitle>contact us</F.FooterTitle>
         <div>213 Baker Street<br />Oriel City Kounty<br />7000 KNW,<br />Kountry Name</div>
         <div>+23 994 233 4022</div>
         <div>info@konstruct.com</div>
      </div>
   )
}